export enum LegalDocumentType {
    TermsOfUse = 'erlbau_customer_portal_terms_of_use',
    BankAgb = 'erlbau_customer_portal_agb_bank',
    BankDataProtection = 'erlbau_customer_portal_data_protection_bank',
    LiabilityDocument = 'erlbau_customer_portal_liability_roof_terms_and_conditions',
    LiabilityCustomerInfoDocument = 'erlbau_customer_portal_liability_roof_customer_info',
    ConsumerInfoPlatformUseDocument = 'erlbau_customer_portal_consumer_info_platform_use',
}

export enum DocOrigin {
    Portfolio = 'portfolio',
    Template = 'template',
    Yield = 'yield',
}

export class Document {

    constructor(
        public id: string,
        public title: string,
        public lastModificationTime: number,
        public src: string,
        public filename: string,
        public fullPath: string,
        public stream: boolean,
        public docOrigin: string
    ) {
    }
    
}

/**
 * get legal document.
 * @param documents
 * @param type
 */
export function getLegalDocument(documents: Document[], type: LegalDocumentType) {
    for (let i = 0; i < documents.length; i++) {
        if (documents[i].id === type) {
            return documents[i];
        }
    }

    return null;
}

export const YIELD_CALCULATION = 'Renditeberechnung';
